import { computed, toRefs, watch } from 'vue'

export default {
    props: {
        message: {
            type: String,
            default: null,
        },
    },
    template: `
        <transition name="v-transition-form-submission">
            <div
                v-if="message"
                class="m-form_submission"
            >
                <p v-html="message"></p>
            </div>
        </transition>
    `
}
